/**
 * Helpdesk URL shape. The backend builds article routes too (it hands the
 * agent a resolved route rather than an id), so these must agree with
 * `article_route` in help_content_service.py.
 */

export const HELP_BASE = "/help"

/** Staff-only management tree, behind HELPDESK_EDIT. */
export const HELP_MANAGE = `${HELP_BASE}/manage`

export const helpCategoryPath = (categoryId: string) =>
  `${HELP_BASE}/${categoryId}`

export const helpArticlePath = (categoryId: string, articleId: string) =>
  `${HELP_BASE}/${categoryId}/${articleId}`
